import * as pigeonTypes from '../pigeon';

export enum BrepCodec {
  None = 0,
  Trans = 206,
  Zip = 207,
}

export {pigeonTypes as pigeon};